<template>
  <div>
    <section-header heading="2" ja="スマホに保存する"/>
    <div class="textArea">
      <p>
        ★Web版の場合<br>
        ■プリクラ（静止画）を保存する<br>
        プリクラONの「アルバム」から保存したい画像をタップすると大きな画像が表示されます。<br>
        大きな画像の下の方にある「プリクラをスマホに保存する」ボタンから保存できます。
      </p>
      <p>
        ■モーメント（動画）を保存する<br>
        プリクラONの「アルバム」から保存したい画像をタップすると大きな画像が表示されます。<br>
        大きな画像の下の方にある「モーメントをスマホに保存する」ボタンから保存できます。
      </p>
      <p>
        ★アプリ版の場合<br>
        ■プリクラ・モーメントを保存する<br>
        アルバムからDLアイコンをタップすることで、スマホに保存することができます。<br>
      </p>
      <p>
        ■複数のプリクラ・モーメントを保存する<br>
        アルバム内のタブを「新着順」に切り替え後、<br>
        「選択」ボタンから複数のプリクラを選択して保存することができます。
      </p>
      <p>
        ■撮影別のプリクラ・モーメントをまとめて保存する<br>
        アルバム内のタブを「撮影別（一括保存）」に切り替え後、<br>
        「まとめてスマホに保存」ボタンから撮影別のプリクラを一括で保存することができます。<br>
        ※一部データが破損している場合は、破損したデータを除き保存されます。
      </p>
    </div>
    <section-header heading="2" ja="スマホに保存ができない"/>
    <div class="textArea">
      <p>
        プリクラONの「アルバム」にあるプリ(画像)やモーメント(動画)のスマホへの保存に失敗してしまう場合は、以下の方法をお試しください。<br>
        <ol>
          <li>「プリクラON」アプリの再起動</li>
          <li>お使いの端末の再起動</li>
          <li>お使いの端末に十分なストレージ（空き容量）があるかの確認</li>
          <li>お客様の通信環境の確認</li>
          <li>Wi-Fiをご利用の場合はオフにし、4G/LTE回線等で問題が発生するか確認</li>
          <li>
            アプリではなく「プリクラON」サイト上からの保存ができないか確認<br>
            <span class="textLink" @click="onWeb()">https://o.puri.jp/</span>
          </li>
          <li>サイトが閉じてしまう場合は、ブラウザのキャッシュクリアをする</li>
        </ol>
      </p>

      <p>
        ★注意事項<br>
        <ul>
          <li>・アプリの「アルバム」の設定で、らくがきをオフにした状態で保存を行なうと、らくがきが無い状態の画像が保存されます。</li>
          <li>・Web版の「アルバム」から、プリを保存する場合、らくがき、背景、メイクをOFFには出来ません。</li>
          <li>・スマホに空き容量がない場合は保存できませんのでご注意ください。</li>
        </ul>
      </p>
    </div>
    <sub-btn @click="onBack()">戻る</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import SubBtn from '@/components/SubBtn.vue'

export default {
  name: "AboutWeb01",
  components: {
    SectionHeader,
    SubBtn
  },
  methods: {
    onBack() {
      if(sessionStorage.getItem('prevPage')) {
        this.$router.push(sessionStorage.getItem('prevPage'))
      } else {
        this.$router.push('/AboutWeb')
      }
    },
    onWeb() {
      window.open('https://o.puri.jp/', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.textArea {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  ol{
    margin-top: 1em;
    list-style-position: inside;
  }
  ul {
    padding-left: 0;
    li {
      list-style-type: none;
      display: block;
    }
  }
  p { margin-top: 1em; }
  .textLink {color: #DA2240;}
}
</style>
